// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAccountClosureAmountsDto
 */
export interface IAccountClosureAmountsDto {
    /**
     * 
     * @type {number}
     * @memberof IAccountClosureAmountsDto
     */
    total_contributions_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IAccountClosureAmountsDto
     */
    toa_amount?: number;
}

/**
 * Check if a given object implements the IAccountClosureAmountsDto interface.
 */
export function instanceOfIAccountClosureAmountsDto(value: object): value is IAccountClosureAmountsDto {
    return true;
}

export function IAccountClosureAmountsDtoFromJSON(json: any): IAccountClosureAmountsDto {
    return IAccountClosureAmountsDtoFromJSONTyped(json, false);
}

export function IAccountClosureAmountsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAccountClosureAmountsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_contributions_amount': json['total_contributions_amount'] == null ? undefined : json['total_contributions_amount'],
        'toa_amount': json['toa_amount'] == null ? undefined : json['toa_amount'],
    };
}

export function IAccountClosureAmountsDtoToJSON(json: any): IAccountClosureAmountsDto {
    return IAccountClosureAmountsDtoToJSONTyped(json, false);
}

export function IAccountClosureAmountsDtoToJSONTyped(value?: IAccountClosureAmountsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total_contributions_amount': value['total_contributions_amount'],
        'toa_amount': value['toa_amount'],
    };
}

